import { ComponentProps } from "react";
import Ribbon from "@components/Ribbon/Ribbon";
import { components } from "@apiSchema";
import { NewsArticleRecordType } from "@enums";
import { sanitizeUrl } from "@helpers";

export const BACKGROUND_TRANSITION_DELAY = 300;
const AUTO_SLIDE_INTERVAL = 10000;


export const RIBBON_DEFAULTS: Partial<ComponentProps<typeof Ribbon>> = {
    minTileWidth: 250,
    maxSlidesPerView: 6,
    autoSlideIntervalMs: AUTO_SLIDE_INTERVAL,
}

type NewsArticle = components["schemas"]["RecentNewsArticleModel"];

export function buildNewsArticleUrl(baseUrl: string | undefined, item: NewsArticle): string {
    const { id = 0, recordType, parentNewsArticleId } = item;
    const base = baseUrl ?? '';

    const isSubArticle =
        recordType === NewsArticleRecordType.SubArticle &&
        (parentNewsArticleId ?? 0) > 0;

    const path = isSubArticle
        ? `${base}/news/article/${parentNewsArticleId}#sub-${id}`
        : `${base}/news/article/${id}`;

    return sanitizeUrl(path);
}